// src/services/missionsService.js
import { collection, doc, getDocs, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from '../firebase/firebase';

const missionsRef = (visitorId) => collection(db, 'visitors', visitorId, 'missions');

export const getCompletedMissionIds = async (visitorId) => {
  if (!visitorId) return new Set();
  const snap = await getDocs(missionsRef(visitorId));
  return new Set(snap.docs.map((d) => d.id));
};

export const markMissionCompleted = async (visitorId, missionId) => {
  if (!visitorId || !missionId) return;
  await setDoc(doc(missionsRef(visitorId), missionId), { completedAt: serverTimestamp() }, { merge: true });
};
